import * as React from 'react';
import { FC } from 'react';
import moment from 'moment/moment';
import { useLocales } from './locales';

const RoundEndNotification: FC<{ endDay: string; lang: string }> = ({ endDay, lang }) => {
  const l = useLocales();
  moment.locale(lang);

  const endDateTime = moment.utc(endDay);
  const nextMonth = endDateTime.clone().add(1, 'months').format('MMMM');

  const formattedEndDate = endDateTime.format('LLL');

  return (
    <div className="l-w_notification" aria-label="round end notification">
      <p>
        {l('round_over')} {formattedEndDate} UTC. {l('next_round')} {nextMonth}.
      </p>
    </div>
  );
};

export default RoundEndNotification;
